'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CheckInAndCheckOut;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CheckInAndCheckOut(props) {
  var checkIn = props.checkIn,
      checkOut = props.checkOut,
      components = props.components,
      t = props.t;


  var styleCheckinTitleLabel = (0, _emailStyleTools.textStyles)(components, 'CheckinTitleLabel');
  var styleCheckinValueLabel = (0, _emailStyleTools.textStyles)(components, 'CheckinValueLabel');
  var styleCheckoutTitleLabel = (0, _emailStyleTools.textStyles)(components, 'CheckoutTitleLabel');
  var styleCheckoutValueLabel = (0, _emailStyleTools.textStyles)(components, 'CheckoutValueLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'CheckInAndCheckOut' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleCheckinTitleLabel },
            t('hotel.checkin')
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleCheckinValueLabel },
            checkIn
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleCheckoutTitleLabel },
            t('hotel.checkout')
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleCheckoutValueLabel },
            checkOut
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/CheckInAndCheckOut.jsx
// module id = 1520
// module chunks = 0